import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { hasPerm, isAdmin } from "@/lib/permissions";

export const ProtectedRoute = ({ children, role, perm }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-12 text-center text-neutral-500">Loading…</div>;
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    const target = role === "admin" ? `/admin/login?next=${next}` : `/login?next=${next}`;
    return <Navigate to={target} replace />;
  }
  if (role === "admin" && !isAdmin(user)) {
    return <Navigate to="/admin/login" replace />;
  }
  if (perm && !hasPerm(user, perm)) {
    return (
      <div className="p-12 text-center" data-testid="forbidden-message">
        <h2 className="font-display text-2xl font-bold text-[#0B1E3F]">Access denied</h2>
        <p className="mt-2 text-neutral-600">Your role ({user.role}) doesn&apos;t have access to this module.</p>
      </div>
    );
  }
  return children;
};
